import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type CancelProSubscriptionMutationVariables = Types.Exact<{ [key: string]: never }>;

export type CancelProSubscriptionMutation = {
	__typename?: 'Mutation';
	cancelStripeSubscription: { __typename?: 'cancelStripeSubscriptionPayload'; isSubscriptionCanceled: boolean };
};

export const CancelProSubscriptionDocument = gql`
	mutation cancelProSubscription {
		cancelStripeSubscription {
			isSubscriptionCanceled
		}
	}
`;
